import { BillingMode } from '../../../../../services/exports/Constants';

export default {
  titles: {
    draft: 'O seu pedido (custo por mês)',
    main: 'A sua subscrição',
    billing_settings: 'Definições de faturação',
  },
  form: {
    billing_mode: {
      label: 'Modo de faturação',
    },
    has_trial: {
      label: 'Adicionar dias de teste gratuitos',
    },
    trial_days: {
      label: 'Quantos dias de teste devem existir?',
      placeholder: '21',
      validation: {
        required: 'Os dias de teste são obrigatórios',
        min: '{{value}} é o valor mínimo para os dias de teste',
        max: '{{value}} é o valor máximo para os dias de teste',
      },
    },
  },
  fields: {
    created_at: 'Criado em <strong>{{date}}</strong> por <strong>{{manager}}</strong>',
    updated_at: 'Última atualização em <strong>{{date}}</strong> por <strong>{{manager}}</strong>',
    trial_ends_at: 'Em período de teste até <strong>{{date}}</strong>',
    trial_days:
      'O período de teste de {{trialDays}} dias começa na data de lançamento; será cobrado quando o período terminar',
    resumable_until: 'Pode ser retomada até <strong>{{date}}</strong>',
    ended_at: 'Terminada em <strong>{{date}}</strong>',
    next_bill_at: 'Próxima cobrança em <strong>{{date}}</strong>',
    product: 'Produto',
    quantity: 'Quantidade',
    price: 'Preço Líquido',
    tax: 'IVA',
    amount: 'Valor',
    net: 'Líquido',
    tax_percentage: 'IVA {{rate}}%',
    total: 'Cobrança total por mês',
  },
  billing_modes: {
    [BillingMode.Stripe]: 'Cobrança pelo método de pagamento',
    [BillingMode.InternalInvoicing]: 'Cobrança sobre as vendas',
  },
  labels: {
    included: 'incluído',
    sales_based_discount:
      'Há um item no cesto com preço variável; o preço real será calculado aquando da criação/atualização da subscrição com base nas métricas de vendas do mês anterior',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    resume: 'Retomar',
  },
  modals: {
    cancel_subscription: {
      title: 'Cancelar subscrição de {{company}}?',
      description:
        'Isto irá cancelar a subscrição selecionada, incluindo <strong>{{products}}</strong> (<strong>{{total}} de montante total</strong>). A subscrição permanece ativa e pode ser retomada até <strong>{{endsAt}}</strong>. Se não for retomada até lá, terá de ser criada uma nova subscrição.',
    },
    resume_subscription: {
      title: 'Retomar subscrição de {{company}}?',
      description:
        'Isto irá retomar a subscrição selecionada, incluindo <strong>{{products}}</strong>. O restaurante é cobrado em <strong>{{total}}</strong> todos os meses, a próxima cobrança a <strong>{{nextBillingDate}}</strong>.',
      description_prorated:
        'Isto irá retomar a subscrição selecionada, incluindo <strong>{{products}}</strong>. A primeira cobrança a <strong>{{nextBillingDate}}</strong> é calculada proporcionalmente até ao dia 5. A partir daí, o restaurante é cobrado em <strong>{{total}}</strong> no dia 5 de cada mês.',
    },
  },
  toasts: {
    cancel_subscription:
      'Se pretender cancelar a sua subscrição, contacte por telefone ou email o seu responsável de conta {{provider}}. O seu contacto cancelará a subscrição imediatamente.',
    failed_to_cancel_subscription: 'Ocorreu um erro ao cancelar a subscrição. Por favor, contacte o suporte técnico',
    resume_subscription:
      'Se pretender retomar a sua subscrição, contacte por telefone ou email o seu responsável de conta {{provider}}. O seu contacto retomará a subscrição imediatamente.',
    failed_to_resume_subscription: 'Ocorreu um erro ao retomar a subscrição. Por favor, contacte o suporte técnico',
  },
};
